var React = require('react');

function PremiumInline (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"0.625","y":"0.625","width":"14.75","height":"14.75","rx":"1.375","fill":"#D4AF37","stroke":"#D4AF37","strokeWidth":"1.25","key":0}),React.createElement("rect",{"x":"1","y":"1","width":"14","height":"14","rx":"1","fill":"#F6EFD7","key":1}),React.createElement("path",{"d":"M6.66667 6L7.52566 3.42303C7.67761 2.96718 8.32239 2.96718 8.47434 3.42302L9.33333 6H12.5746C13.0472 6 13.256 6.59518 12.887 6.89043L10.3158 8.94737L11.4646 12.3938C11.6222 12.8665 11.067 13.2536 10.6779 12.9423L8 10.8L5.3221 12.9423C4.93303 13.2536 4.37785 12.8665 4.53541 12.3938L5.68421 8.94737L3.11304 6.89043C2.74397 6.59518 2.95275 6 3.42539 6H6.66667Z","fill":"#D4AF37","key":2})]);
}

PremiumInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = PremiumInline;

PremiumInline.default = PremiumInline;
